import { getCoreDataSecurityAppStatusSlice } from './get';

export const { requestGetCoreDataSecurityAppStatus, resetGetCoreDataSecurityAppStatus } =
	getCoreDataSecurityAppStatusSlice.asyncActionCreators;
